import { Carousel, Typography } from "antd";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import homeCarouselImage1 from "../../Assets/carouselImage1_1.png";
import homeCarouselImage2 from "../../Assets/carouselImage2_1.png";
import homeCarouselImage3 from "../../Assets/carouselImage3_2.png";
import icon from "../../Assets/icon_white.png";
import icon1 from "../../Assets/icon5.png";
import { translation } from "../../i18n/translationConstant";
import { Context } from "../Authentication/Components/Login";
import "./index.css";

const HomePage: React.FC = () => {
  const { t } = useTranslation();
  const { Text, Paragraph } = Typography;
  const { slide, setSlide }: any = useContext(Context);

  const slideChange = (_currentSlide: number, nextSlide: number) => {
    setSlide(nextSlide);
  };

  return (
    <div
      className="homePageRoot"
      style={{
        backgroundColor:
          slide === 0
            ? "var(--hintSecondaryColor)"
            : slide === 1
            ? "var(--primaryColor)"
            : "var(--cardColor)",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            fontSize: 20,
            fontWeight: 500,
            color: slide === 2 ? "#000000" : "#FFFFFF",
            marginTop: 30,
          }}
        >
          Welcome to
        </div>
        {slide != 2 ? (
          <img style={{ height: 40, width: 100 }} src={icon} alt="" />
        ) : (
          <img style={{ height: 40, width: 100 }} src={icon1} alt="" />
        )}
      </div>
      <Carousel
        beforeChange={slideChange}
        className="carouselStyle"
        autoplay={true}
        dots={{ className: "dots" }}
      >
        <div id="carouselLayout">
          <img
            style={{ height: 280, width: 250 }}
            src={homeCarouselImage1}
            alt=""
          />
          <Paragraph className="typoGraphyPara">
            <Text className="carouselText" strong={true}>
              {t(translation.lblSecondBoardingFirst)}
            </Text>{" "}
            {t(translation.lblSecondBoardingSecond)}
          </Paragraph>
        </div>

        <div id="carouselLayout">
          <img
            style={{ height: 280, width: 220 }}
            src={homeCarouselImage2}
            alt=""
          />
          <Paragraph className="typoGraphyPara">
            <Text className="carouselText" strong={true}>
              {t(translation.lblFirstBoardingFirst)}
            </Text>{" "}
            {t(translation.lblAAProfile)}
          </Paragraph>
        </div>

        <div id="carouselLayout">
          <img
            style={{ marginLeft: '100px', height: 280, width: 240, objectFit: "cover" }}
            src={homeCarouselImage3}
            alt=""
          />
          <Paragraph className="typoGraphyPara3">
            <Text className="carouselText3" strong={true}>
              {t(translation.lblThirdBoardingFirst)}
            </Text>{" "}
            {t(translation.lblAAProfile)}
          </Paragraph>
        </div>
      </Carousel>
    </div>
  );
};

export default HomePage;
